<script>
	import MultiSelect from "./MultiSelect.svelte";
	import businessLocations from "../stores/businessLocationsStore";
	import { createEventDispatcher } from "svelte";
	import lookups from "../stores/lookupStore";

	export let tags = [];
	export let readonly = false;
	export let businessId = 0;
	export let businesses = true;
	export let business = null;
	console.log(tags, "tags");
	console.log(businessId, "businessId");

	const dispatch = createEventDispatcher();

	let tagValues = [];
	let tagOptions = [];

	const handleChange = async (e) => {
		dispatch("change");
	};

	const addTag = async (e) => {
		let t = e.detail.value;
		tags.push({ label: t, value: t });
	};

	const removeTag = async (e) => {
		let t = e.detail.value;
		let indexToRemove = tags.findIndex((t) => t.value == t);
		tags.splice(indexToRemove, 1);
	};

	const initialise = async () => {
		if (tags) {
			tagValues = tags.map((t) => t.value);
		}

		if (businesses) {
			tagOptions = $businessLocations[businessId]
				?.map((t) => ({ name: t.locationName, value: t.locationName }))
				.sort((a, b) => a.name.localeCompare(b.name));
			console.log(tagOptions);
		} else {
			if (business === "McDonald's") {
				tagOptions = [
					"Peter Russo Investments Pty Ltd",
					"Sedah Pty Ltd",
					"Ballavarra Pty Ltd",
					"Ardeen Pty Ltd",
					"Majero Investments Pty Ltd",
					"Jameri Pty Ltd",
					"Neka Enterprises Pty Ltd",
					"Kalbak Pty Ltd",
					"Bandec Pty Ltd",
					"Gintonak Pty Ltd",
					"BL Edwards Group Pty Ltd",
					"Nieumorr Pty Ltd",
					"Nimali Pty Ltd",
					"Big 3 Group Pty Limited",
					"J & M Hodge Investments Pty Ltd",
					"PWR Enterprises Pty Ltd",
					"Dutschke Enterprises Pty Ltd",
					"Paderson Pty Ltd"
				].map((t) => ({ name: t, value: t }));
			} else {
				tagOptions = ["On The Run Pty Ltd", "Shahin Enterprises", "SEPL Pty Ltd"].map((t) => ({
					name: t,
					value: t
				}));
			}
		}
	};
</script>

{#await initialise()}
	<p>... loading outlets</p>
{:then}
	{#if $businessLocations[businessId]}
		<MultiSelect
			{readonly}
			placeholder="Start typing"
			bind:value={tagValues}
			options={tagOptions}
			on:change={(e) => handleChange(e)}
			on:remove={(e) => removeTag(e)}
			on:add={(e) => addTag(e)}>
			{#each $businessLocations[businessId].sort as tag, i (tag)}
				<option value={tag.locationName}>{tag.locationName}</option>
			{/each}
		</MultiSelect>
	{/if}
{/await}

<style>
	@keyframes shake {
		0% {
			transform: translate(7px);
		}
		20% {
			transform: translate(-7px);
		}
		40% {
			transform: translate(3px);
		}
		60% {
			transform: translate(-3px);
		}
		80% {
			transform: translate(1px);
		}
		100% {
			transform: translate(0px);
		}
	}
</style>
